// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IModelResponse, IModel } from '@cian/http-api';
import type { IGraphDataSchema } from '../../entities/graph/GraphDataSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export interface IGetGraphDataRequest {
  /** Тип графика **/
  graphType: EGraphType;
}
export enum EGraphType {
  /** Число сделок с физическими лицами на первичном рынке **/
  'DealCountPrimary' = 'dealCountPrimary',
  /** Доля ипотечных сделок на первичном рынке **/
  'DealPercentPrimary' = 'dealPercentPrimary',
  /** Средняя цена квадратного метра на вторичном рынке **/
  'PriceSqmSecondary' = 'priceSqmSecondary',
}

export type IGetGraphDataResponse = IGraphDataSchema;

export interface IGetGraphDataResponse200 extends IModelResponse<IGetGraphDataResponse> {
  statusCode: 200;
}

export type IGetGraphDataResponseError = IErrorResponseSchema;

export interface IGetGraphDataResponse400 extends IModelResponse<IGetGraphDataResponseError> {
  statusCode: 400;
}

export type TGetGraphDataResponse = IGetGraphDataResponse200 | IGetGraphDataResponse400;

export type TGetGraphDataModel = IModel<IGetGraphDataRequest, TGetGraphDataResponse>;

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetGraphDataResponse): TResponse200;
  400(response: IGetGraphDataResponseError): TResponse400;
}
